import { render, staticRenderFns } from "./appRightToAppealInstructions.vue?vue&type=template&id=42b998f7"
import script from "./appRightToAppealInstructions.vue?vue&type=script&lang=ts"
export * from "./appRightToAppealInstructions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports